// jshint esversion: 6
export default {
  token: null
}
